// libs
import React, { memo } from 'react';

// components
import { Desktop as DealsPlatformRenderer } from 'shared/components/DealsPlatformRenderer';
import AdPlatformWidgetsDesktop from 'shared/components/AdPlatformWidgets/Desktop';

// hooks
import useDealsPlatformRedirect from 'shared/hooks/useDealsPlatformRedirect';

// constants
import { EAGER_IMAGE_LOADING_COUNT } from 'shared/constants';

// helpers
import logger from 'shared/logger';

// defs
import { ILandingPageProps } from 'shared/components/AdPlatformWidgets/types';

interface DealsPlatformRender {
  landingPageData: ILandingPageProps['landingPageData'];
  pageName: string;
  eagerLoadingCount?: number;
}

function Desktop({
  landingPageData,
  pageName,
  eagerLoadingCount = EAGER_IMAGE_LOADING_COUNT,
}: DealsPlatformRender) {
  const shouldRenderWithDealsPlatform = useDealsPlatformRedirect(pageName);

  logger.info({
    information: 'AD_PLATFORM_VERSION',
    version: shouldRenderWithDealsPlatform ? 'V2' : 'V1',
    pageName,
    platform: 'dweb',
  });

  if (shouldRenderWithDealsPlatform) {
    return (
      <DealsPlatformRenderer
        landingPageData={landingPageData}
        pageName={pageName}
        eagerLoadingCount={eagerLoadingCount}
      />
    );
  }

  return <AdPlatformWidgetsDesktop landingPageData={landingPageData} />;
}

export default memo(Desktop);
